// StockTransactions.jsx  → simplified & self-contained version
import React, { useState, useEffect } from "react";
import moment from "moment";
import Loading from "../../components/loading";
import { getStockTransaction } from "../../services/services";
import { toastError } from "../../utils"; 
import Pagination from "../../components/Pagination";

const StockTransactions = ({ selectedProduct, isLoading: externalLoading }) => {
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    if (!selectedProduct?._id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getStockTransaction(
          selectedProduct._id,
          currentPage,
          itemsPerPage,
        );

        const data = res.data.response;

        const formatted = data.transactions.map((tx) => ({
          _id: tx._id,
          type: tx.type,
          quantity: tx.quantity,
          date: tx.createdAt,
          referenceId: tx.referenceId,
        }));

        setTransactions(formatted);
        setTotalPages(data.totalPages);
        setTotalItems(data.total);
      } catch (err) {
        toastError("Failed to load stock transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedProduct?._id, currentPage, itemsPerPage]);

  if (externalLoading || loading) {
    return (
      <div className="py-5 text-center">
        <Loading />
      </div>
    );
  }

  if (transactions.length === 0) {
    return (
      <div className="text-center bg-white text-muted py-5 mt-3 rounded">
        No stock transactions found
      </div>
    );
  }

  return (
    <div className="border-0 mt-3">
      {/* <p className="">Stock Transactions </p> */}

      <div className="card-body p-0 rounded overflow-hidden border mb-2">
        <div
          className="d-flex justify-content-between px-3 py-2 text-white "
          style={{ backgroundColor: "#0b2b6d", fontSize:"13px" }}
        >
          <div style={{ flex: "1 1 45%" }}>Type</div>
          <div style={{ flex: "1 1 30%", textAlign: "center" }}>Quantity</div>
          <div style={{ flex: "1 1 25%", textAlign: "right" }}>Date</div>
        </div>

        <ul className="list-group list-group-flush">
          {transactions.map((tx) => (
            <li key={tx._id} className="list-group-item px-3 py-1">
              <div className="d-flex align-items-center">
                <div style={{ flex: "1 1 45%" }}>
                  <span
                    className={`badge rounded-pill py-1 ${
                      ["purchase", "saleReturn"].includes(tx.type)
                        ? "success-subtle text-success"
                        : "danger-subtle text-danger"
                    }`}
                  >
                    {tx.type.toUpperCase()}
                  </span>
                </div>
                <div style={{ flex: "1 1 30%", textAlign: "center" }}>
                  <small>{Math.abs(tx.quantity)}</small>
                </div>
                <div style={{ flex: "1 1 25%", textAlign: "right" }}>
                  <small>{moment(tx.date).format("DD MMM, YYYY")}</small>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <Pagination
        page={currentPage}
        totalPages={totalPages}
        limit={itemsPerPage}
        totalItems={totalItems}
        loading={loading}
        onPageChange={setCurrentPage}
        onLimitChange={setItemsPerPage}
      />
    </div>
  );
};

export default StockTransactions;
